import React from 'react';
import ReactDOM from 'react-dom';
import { AgentLoginInfo, RitzAPI, RitzWebSocketFactory } from '@moderepo/mode-internal-apis';
import { AppAPI, WebSocketFactory } from '@moderepo/mode-apis';
import App from './containers/app/App';
import * as serviceWorker from './serviceWorker';
import * as Constants from './utils/constants';
import { initializeDefaultProjectType } from './containers/routes/defaultProjectConfig';
import { initializeSensorCloudProjectType } from './containers/sensor-cloud/SCProjectConfig';
import { initializeRobotCloudProjectType } from './containers/robot-cloud/RCProjectConfig';



if (!process.env.REACT_APP_RITZ_API_BASE_URL || !process.env.REACT_APP_MAZE_API_BASE_URL) {
    throw new Error(`Missing variable "REACT_APP_RITZ_API_BASE_URL" or "REACT_APP_MAZE_API_BASE_URL". Please make sure you have an .env \
file in your project root directory and it contains the required params. Please see .env_sample file for example.
    `);
}

// Check if we already have the agent's login info stored in localStorage from the previous login
// If we have it, we might be able to skip login.
const loginInfo = ((): AgentLoginInfo | undefined => {
    const data = window.localStorage.getItem(Constants.LS_KEY_LOGIN_INFO);
    if (data) {
        try {
            return JSON.parse(data) as AgentLoginInfo;
        } catch (error) {
            // invalid LoginInfo stored in local storage, remove it from local storage
            window.localStorage.removeItem(Constants.LS_KEY_LOGIN_INFO);
        }
    }
    return undefined;
})();

// Initialize the BASE_URL for each of the API server
RitzAPI.initialize(process.env.REACT_APP_RITZ_API_BASE_URL, loginInfo ? loginInfo?.xsrfGuard : undefined);
RitzWebSocketFactory.initialize(process.env.REACT_APP_RITZ_API_BASE_URL.replace(/http/, 'ws'));
AppAPI.initialize(process.env.REACT_APP_MAZE_API_BASE_URL);
WebSocketFactory.initialize(process.env.REACT_APP_MAZE_API_BASE_URL.replace(/http/, 'ws'));


// Initialize Project Type handler e.g. RobotCloud, SensorCloud, MobilityCloud, etc...
initializeDefaultProjectType();
initializeSensorCloudProjectType();
initializeRobotCloudProjectType();


ReactDOM.render(<App />, document.getElementById('root'));


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
